export default "__VITE_ASSET__BG7DW7wc__"